import React from 'react';
import { 
  faSortAlphaDown, 
  faSortAlphaUp, 
  faCircleCheck, 
  faCircleXmark,
  faClockRotateLeft,
  faClock,
  faXmark,
  faCheck,
  faRotateLeft
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './SortModal.module.css';
import { useTranslation } from 'react-i18next';

const SortModal = ({ 
  isOpen,
  onClose,
  selectedSort,
  setSelectedSort,
  applySort,
  resetSorting
}) => {
  const { t } = useTranslation();
  const sortOptions = [
    {
      id: 'name-asc',
      label: t('sortModal.nameAsc'),
      icon: faSortAlphaDown
    },
    {
      id: 'name-desc',
      label: t('sortModal.nameDesc'),
      icon: faSortAlphaUp
    },
    {
      id: 'status-online',
      label: t('sortModal.statusOnline'),
      icon: faCircleCheck
    },
    {
      id: 'status-offline',
      label: t('sortModal.statusOffline'),
      icon: faCircleXmark
    },
    {
      id: 'recent-first',
      label: t('sortModal.recentFirst'),
      icon: faClockRotateLeft
    },
    {
      id: 'oldest-first',
      label: t('sortModal.oldestFirst'),
      icon: faClock
    }
  ];

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>{t('sortModal.title')}</h3>
          <button 
            onClick={onClose}
            className={styles.modalClose}
            aria-label={t('sortModal.close')}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className={styles.sortOptions}>
          {sortOptions.map(option => (
            <div
              key={option.id}
              className={`${styles.sortOption} ${selectedSort === option.id ? styles.active : ''}`}
              onClick={() => setSelectedSort(option.id)}
            >
              <div className={styles.optionContent}>
                <FontAwesomeIcon icon={option.icon} className={styles.optionIcon} />
                <span>{option.label}</span>
              </div>
              {selectedSort === option.id && (
                <FontAwesomeIcon 
                  icon={faCheck} 
                  className={styles.checkIcon} 
                />
              )}
            </div>
          ))}
        </div>

        <div className={styles.modalFooter}>
          <button 
            onClick={resetSorting}
            className={styles.resetButton}
          >
            <FontAwesomeIcon icon={faRotateLeft} />
            <span>{t('sortModal.reset')}</span>
          </button>
          <button 
            onClick={applySort}
            className={styles.applyButton}
            disabled={!selectedSort}
          >
            {t('sortModal.apply')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortModal;